import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WorkItemListComponent } from './workitem-list.component';
import { TraversableListModule } from './shared/traversable-list/traversable-list.module';
import { WorkItemLensListModule } from 'components/accordion/workitem-list/workitem-lens-list/work-item-lens-list.module';
import { WorkItemChatListModule } from 'components/accordion/workitem-list/workitem-chat-list/work-item-chat-list.module';
import { WorkItemTextChatListModule } from 'components/accordion/workitem-list/workitem-text-chats-list/workitem-text-chat-list.module';
import { WorkItemEmailListModule } from 'components/accordion/workitem-list/workitem-email-list/workitem-email-list.module';
import { WorkItemDiscussionListModule } from 'components/accordion/workitem-list/workitem-discussion-list/workitem-discussion-list.module';
import { WorkItemGenesysChatListModule } from 'components/accordion/workitem-list/workitem-genesys-chat-list/workitem-genesys-chat-list.module';
import { WorkItemGenesysEmailListModule } from 'components/accordion/workitem-list/workitem-genesys-email-list/workitem-genesys-email-list.module';
import { IfFeatureEnabledModule } from 'shared/directives/if-feature-enabled';
import { GenesysUserPermissionCheckModule } from 'shared/directives/genesys-user-permission-check';
import { SvgIconModule } from 'shared/components/svg-icon/svg-icon.module';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  imports: [
    CommonModule,
    WorkItemDiscussionListModule,
    WorkItemLensListModule,
    WorkItemChatListModule,
    WorkItemGenesysChatListModule,
    WorkItemTextChatListModule,
    WorkItemEmailListModule,
    WorkItemGenesysEmailListModule,
    TraversableListModule,
    IfFeatureEnabledModule,
    GenesysUserPermissionCheckModule,
    SvgIconModule,
    TranslateModule
  ],
  declarations: [
    WorkItemListComponent
  ],
  exports: [
    WorkItemListComponent
  ]
})
export class WorkItemListModule {}
